import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const deleteContract = createProvider(api.deleteContract).andThen((res) => res);
